import { createContext } from 'react';

export type TopBarStationId = '1' | '2' | '3' | '4' | 'avg';

export interface TopBarStationContextType {
  topBarStationId: TopBarStationId;
  setTopBarStationId: (id: TopBarStationId) => void;
}

export const TopBarStationContext = createContext<TopBarStationContextType | undefined>(undefined);
